import {
    COMPETENCES,
    MATURITY,
    POTENTIAL
} from '@/model/rating/categories'

export default {
    title: 'Macro-trend',

    // TODO: remove
    category: {
        [POTENTIAL]: 'Potential',
        [MATURITY]: 'Maturity',
        [COMPETENCES]: 'Competences'
    },
    // ---

    section: {
        discussions: {
            title: 'Posts',
            extendedSources: 'Information ({count})',
            chances: 'Chances ({count})',
            risks: 'Risks ({count})'
        },
        innovationfields: 'Innovation fields',
        insider: 'Insider'
    },
    option: {
        low: 'low',
        moderate: 'moderate',
        high: 'high',
        epic: 'very high'
    }
}
